module.exports = __webpack_public_path__ + "img/paper.f8afc770.jpg";